import { LoadingIcon as LoadingDs, Typography } from "@packages/ds";
import styled from "styled-components";

import { Separator as DSSeparator } from "ds/Dropdown";
import * as Sticker from "ds/Sticker";

export const DialogWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 24px 0 16px;
`;

export const NoteText = styled(Typography.BodyText)`
  margin-top: 24px;
`;

export const LoadingSuccess = styled(LoadingDs)`
  display: block;
  margin: 50px 0 0 auto;
`;

export const Separator = styled(DSSeparator)`
  margin: 24px 0px 20px 0px;
`;

export const RedeployText = styled(Typography.BodyText)<{ isGrayed: boolean }>`
  margin-left: 30px;
  color: ${props =>
    props.isGrayed
      ? "var(--mode-text-neutral-weakest-disabled)"
      : "var(--slate-600)"};
`;

export const RedeployWrapper = styled.div`
  margin-top: 16px;
`;

export const StickerRoot = styled(Sticker.Root)`
  margin-bottom: 16px;
`;
export const CLI = styled(Typography.BodyText)`
  margin-bottom: 8px;
`;
